<template>

    <div class="stages-detail-page admin-page">
        <Header></Header>
        <vue-ins-progress-bar></vue-ins-progress-bar>
        <section class="contact-section">
            <div class="container">
                <div class="row admin-bar">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <router-link class="next-icon prev-b" :to="`/admin/people`"><img src="@/assets/img/prev.svg"/> People List</router-link>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Edit People</h2>
                        <form class="form" v-on:submit.prevent="uploadImgages" enctype="multipart/form-data">
                            <div class="input-field form-input">
                                <label for="your-title">Name</label>
                                <input type="text" placeholder="Name" v-model="name" id="your-title">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-title">Designation</label>
                                <input type="text" placeholder="Designation" v-model="designation" id="your-designation">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Profile Image</p>
                                <label for="video_image">
                                    <span>{{peopleImage}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="video_image" ref="file" v-on:change="handleProfileUpload">
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-description">Description</label>
                                <textarea placeholder="Description..." id="your-description" v-model="description" style="min-height: 150px;"></textarea>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-linkedin">LinkedIn</label>
                                <input type="text" placeholder="LinkedIn" v-model="linkedin" id="your-linkedin">
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Header from '../Header'
    import Footer from '../Footer'
    import router from '../../../router'
    import VueInsProgressBar from 'vue-ins-progress-bar'
    import axios from 'axios'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    const options = {
        position: 'fixed',
        show: true,
        height: '5px'
    }
    Vue.use(VueInsProgressBar, options)
    export default {
        name: 'AdminPeopleEdit',
        components: {
            'Header': Header,
            'Footer': Footer,
            'tags-input': VoerroTagsInput
        },
        data () {
            // router.push({ name: 'Login' })
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                name: '',
                designation: '',
                description: '',
                linkedin: '',
                FormSubmited: false,
                // videoImageFile: '',
                ImageFile: '',
                userData: userdata,
                peopleImage: 'Profile Image',
                peopleId: router.history.current.params.id,
                tags: [],
                selectedTags: []
            }
        },
        mounted () {
            // stageId
            axios
                .get('/getPeopleById', {
                    params: {
                        peopleId: this.peopleId
                    }
                })
                .then(response => {
                    this.name = response.data.name
                    this.designation = response.data.designation
                    this.description = response.data.description
                    this.linkedin = response.data.linkedin
                    this.peopleImage = response.data.images[0].bgImageName
                    // this.videoName = response.data.videoId[0].videoName
                    this.imageId = response.data.images[0]._id

                })
                .catch(error => console.log(error))
        },
        methods: {
            editPeopleForm(){
                try {
                    axios.post('/editpeople', {
                        name: this.name,
                        description: this.description,
                        designation: this.designation,
                        linkedin: this.linkedin,
                        id: this.peopleId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        this.FormSubmited = false
                        this.$insProgress.finish()
                        Vue.$toast.open(
                            {
                                message: 'People Updated successfully!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }).catch(err => {
                        this.FormSubmited = false
                        console.log(err)
                    })
                } catch (e) {
                    this.FormSubmited = false
                    console.log(e)
                }
            },
            handleProfileUpload(){
                this.ImageFile = this.$refs.file.files[0]
                this.peopleImage = this.$refs.file.files[0].name
            },
            async uploadImgages () {
                this.FormSubmited = true
                this.$insProgress.start()
                if(this.ImageFile){
                    const formData = new FormData()
                    formData.append('peopleImage', this.ImageFile)
                    formData.append('imageId', this.imageId)
                    try {
                        axios.post('/peopleimageedit', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.editPeopleForm()
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                   this.editPeopleForm()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/people/Edit.vue